<template>
  <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-media
              class="edomargintop"
              height="450px">
              <googlemaps-map
                ref="map"
                class="map"
                :center.sync="center"
                :zoom.sync="zoom">

                <!-- Marker -->
                <googlemaps-marker
                  title="Edologic GmbH"
                  :position="{ lat: 51.217995, lng: 7.2852063 }"/>
              </googlemaps-map>
            </v-card-media>
          </v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-space-around>
              <v-flex d-flex xs12 sm6 md5>
                <v-card class="edomargintop">
                  <div itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                  <v-card-title primary class="title edoheadlinetext">
                  <span itemprop="name">
                  DIE EDOLOGIC
                  </span>
                  </v-card-title>
                  <v-card-text class="edoLineText">
                  <span itemprop="name">
                    edologic GmbH <br><br>
                  </span>
                    <span itemprop="streetAddress">
                  In der Hardt 3 <br>
                    </span>
                    <span itemprop="postalCode">
                  42399
                    </span>
                    <span itemprop="addressLocality">
                      Wuppertal<br><br>
                    </span>
                    <span itemprop="telephone">
                  +49 202 - 947 996 20<br>
                    </span>
                    <a href="mailto:info@edologic.de" itemprop="email">info@edologic.de</a>
                  </v-card-text>
                  </div>
                </v-card>
              </v-flex>
            <v-flex d-flex xs12 sm6 md5>
              <v-card class="edomargintop">
                <div itemscope itemtype="http://schema.org/OpeningHoursSpecification">
                <v-card-title primary class="title edoheadlinetext">GESCHÄFTSZEITEN</v-card-title>
                <v-card-text>
                  <v-container fluid grid-list-md>
                  <v-layout row>
                      <v-container class="edotabtext">
                        <link itemprop="dayOfWeek" href="http://schema.org/Monday"/>
                        Montag:
                        <span style="padding-left: 100px">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                          </span>
                      </v-container>
                  </v-layout>
                  <v-layout row>
                    <v-container class="edotabtext">
                        <link itemprop="dayOfWeek" href="http://schema.org/Tuesday" />
                      Dienstag:
                      <span style="padding-left: 93px">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                      </span>
                      </v-container>
                  </v-layout>
                    <v-layout row>
                      <v-container class="edotabtext">
                        <link itemprop="dayOfWeek" href="http://schema.org/Wednesday" />
                        Mittwoch:
                        <span style="padding-left: 92px">
                          <time itemprop="opens" content="09:00:00">
                            9:00
                          </time>
                          -
                          <time itemprop="closes" content="17:00:00">
                            17:00
                          </time>
                        </span>
                        </v-container>
                    </v-layout>
                    <v-layout row>
                      <v-container class="edotabtext">
                        <link itemprop="dayOfWeek" href="http://schema.org/Thursday" />
                        Donnerstag:
                        <span style="padding-left: 74px">
                          <time itemprop="opens" content="09:00:00">
                            9:00
                          </time>
                          -
                          <time itemprop="closes" content="17:00:00">
                            17:00
                          </time>
                        </span>
                        </v-container>
                    </v-layout>
                    <v-layout row>
                      <v-container class="edotabtext">
                        <link itemprop="dayOfWeek" href="http://schema.org/Friday" />
                        Freitag:
                        <span style="padding-left: 105px">
                          <time itemprop="opens" content="09:00:00">
                            9:00
                          </time>
                          -
                          <time itemprop="closes" content="15:00:00">
                            15:00
                          </time>
                        </span>
                        </v-container>
                    </v-layout>
                  </v-container>
                </v-card-text>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-container>
        <v-card class="edoabstandfooter">
        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import Vue from 'vue'
  import VueGoogleMaps from 'vue-googlemaps'
  export default {
    name: 'Contact',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Kontakt – Ihr Draht zur edologic',
      meta: [
        {
          name: 'description',
          content: 'Sie suchen unsere Adresse oder Geschäftszeiten? Hier sind Sie richtig.'
        }]
    },
    data () {
      return {
        center: {
          lat: 51.217995,
          lng: 7.2852063
        },
        userPosition: null,
        zoom: 13
      }
    },

    methods: {
      ...mapActions('layout', [
        'toggleSideNav'
      ])
    },
    created () {
      Vue.use(VueGoogleMaps, {
        load: {
          apiKey: 'AIzaSyAetXJoHCE7Ealp9F5OECNvOF6hItEPabk',
          libraries: ['places']
        }
      })
    },
    mounted () {
      console.log('Contact')
    }
  }
</script>

<style scoped>
  .demo {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .map {
    width: 100%;
    height: 100%;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: gray;
    -webkit-filter: grayscale(1);
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue